import React, { useEffect, useState } from "react";
import { Table, Empty, Row, Col, Divider } from "antd";
import { BarsOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import moment from "moment";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "../../util/TableHelper";
import { useMediaQuery } from "react-responsive";
import { odata, queryHelper } from "../../routes/Filters/Helper/index";

const FirmTrackingTransactionDetail = (props) => {
  //console.log("props DetaY SAYFASI EKNRAI BİLGİLİERİNİN OLDUĞU YER ", props);
  const history = useHistory();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );

  const [processTypeName, setProcessTypeName] = useState("");
  const [transactionDate, setTransactionDate] = useState("");

  const [itemProductName, setItemProductName] = useState("");
  const [itemProductCount, setitemProductCount] = useState("");
  const [itemKdvPercent, setitemKdvPercent] = useState("");
  const [itemAmountWithKdv, setitemAmountWithKdv] = useState("");
  const [itemAmount, setitemAmount] = useState("");
  const [itemDate, setItemDate] = useState("");
  const [itemAddDate, setItemAddDate] = useState("");
  const [itemCurrencyCode, setItemCurrencyCode] = useState("");
  const [itemSalesCode, setitemSalesCode] = useState("");
  const [currencyCode, setCurrencyCode] = useState("");

  useEffect(() => {
    if (props.clickedButton) {
      //console.log("detail props.MonthlyplanId =>  ", props.MonthlyPlanId);
      getEInvoiceOrEArchiveData(props.MonthlyPlanId);
    } else {
      getEInvoiceOrEArchiveData(props.newPageMonthlyId);
    }

    RequestHandler.post(
      `/FirmTracking/GetTransactionById`,
      {
        transactionId:
          props.transactionId != "null"
            ? props.transactionId
            : "00000000-0000-0000-0000-000000000000",
        planId:
          props.planId != "null"
            ? props.planId
            : "00000000-0000-0000-0000-000000000000",
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        setTableData({
          data: res.data,
          total: 1,
          loading: false,
        });
        setProcessTypeName(res.data[0].processTypeName);
        setTransactionDate(res.data[0].transactionDate);
      } else {
        setTableData({
          data: [],
          total: 0,
          loading: false,
        });
      }
    });
  }, []);

  const getEInvoiceOrEArchiveData = (id) => {
    RequestHandler.get(`/FirmTracking/GetEArchiveOrEInvoice/${id}`).then(
      (res) => {
        if (res.eInvoiceItems && res.eInvoiceItems.length > 0) {
          // Dizi tanımlı ve en az bir öğe içeriyor
          setItemProductName(res.eInvoiceItems[0].productName);
          setitemProductCount(res.eInvoiceItems[0].productCount);
          setitemAmountWithKdv(res.eInvoiceItems[0].amountWithKdv);
          setitemAmount(res.eInvoiceItems[0].amount);
          setitemSalesCode(res.eInvoiceItems[0].salesCode);
          setitemKdvPercent(res.eInvoiceItems[0].kdvPercent);
          setItemDate(res.date);
          setItemAddDate(res.addDate);
          setItemCurrencyCode(res.currencyCode);
        }
      }
    );
  };

  const calculateDelay = (date) => {
    const currentDate = moment();
    const transactionDate = moment(date, "DD.MM.YYYY HH:mm");
    const daysDiff = currentDate.diff(transactionDate, "days");

    if (daysDiff === 0) {
      return `${transactionDate.format("DD.MM.YYYY")} (Bugün)`;
    } else if (daysDiff > 0) {
      return `${transactionDate.format(
        "DD.MM.YYYY"
      )} (${daysDiff} Günlük Gecikme)`;
    } else {
      return `${transactionDate.format("DD.MM.YYYY")} (${Math.abs(
        daysDiff
      )} Gün Erken)`;
    }
  };

  const formatItemDate = moment(itemDate).format("DD.MM.YYYY HH:mm");
  const formatItemAddDate = moment(itemAddDate).format("DD.MM.YYYY HH:mm");

  // let currencyCodeValue;
  // console.log("asd", itemCurrencyCode);
  // if (itemCurrencyCode === "TRY") {
  //   currencyCodeValue = "TL";
  //   setCurrencyCode(currencyCodeValue);
  // } else if (itemCurrencyCode === "USD") {
  //   currencyCodeValue = "USD";
  //   setCurrencyCode(currencyCodeValue);
  // } else if (itemCurrencyCode === "EUR") {
  //   currencyCodeValue = "EUR";
  //   setCurrencyCode(currencyCodeValue);
  // } else if (itemCurrencyCode === "GBP") {
  //   currencyCodeValue = "GBP";
  //   setCurrencyCode(currencyCodeValue);
  // }

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Hizmet/Ürün",
      dataIndex: "productName",
      key: "productName",
      align: "left",
      render: () => {
        const productName = itemProductName;
        return <span>{productName} </span>;
      },
    },
    {
      title: "Miktar",
      dataIndex: "amount",
      key: "amount",
      align: "left",
      render: () => {
        const productCount = itemProductCount;
        return <span>{productCount} Adet</span>;
      },
    },
    {
      title: "Birim Fiyat",
      dataIndex: "unitPrice",
      key: "unitPrice",
      align: "center",
      render: () => {
        const amount = itemAmount;
        return <span>{amount} TL</span>;
      },
    },
    {
      title: "Vergi",
      dataIndex: "tax",
      key: "tax",
      align: "left",
      render: () => {
        const kdvPercent = itemKdvPercent;
        return <span>KDV %{(kdvPercent * 100).toFixed(2)}</span>;
      },
    },
    {
      title: "Vergisiz Toplam Tutar",
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "center",
      render: () => {
        const amountWithKdv = itemAmountWithKdv;
        return <span>{itemAmount * itemProductCount} TL</span>;
      },
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      align: "reight",
    },
  ];

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const summaryColumns = [
    {
      title: "",
      dataIndex: "title",
      key: "title",
      align: "right",
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
      align: "right",
    },
  ];

  const summaryDataSource = [
    {
      key: "1",
      title: "Mal/Hizmet Toplam Tutar:",
      value: `${itemAmount * itemProductCount} TL`,
    },
    {
      key: "2",
      title: "Hesaplanan Kdv:",
      value: `${itemAmount * itemProductCount * itemKdvPercent} TL`,
    },
    {
      key: "3",
      title: "Vergiler Dahil Toplam Fiyat:",
      value: `${itemAmountWithKdv} TL`,
    },
    {
      key: "4",
      title: "Ödenecek Tutar:",
      value: `${itemAmountWithKdv} TL`,
    },
  ];

  return (
    <div>
      <Row id="titleArea">
        <Col xs={24} md={12} lg={5}>
          <h1 style={{ marginBottom: 0 }}>
            <BarsOutlined /> İşlem Detayı
          </h1>
        </Col>

        <Col
          xs={24}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "center" }}
        >
          <span style={{ marginRight: "8px" }}>İşlem Tipi:</span>
          <span>
            {processTypeName === "Satış Faturası"
              ? "Alış Faturası"
              : "Satış Faturası"}
          </span>
        </Col>
        <Col
          xs={24}
          md={12}
          lg={8}
          style={{ display: "flex", alignItems: "center" }}
        >
          <span style={{ marginRight: "8px" }}>İşlem Tarihi:</span>
          <span>{formatItemAddDate}</span>
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
          style={{ display: "flex", alignItems: "center" }}
        >
          <span style={{ marginRight: "8px" }}>Ödeme Tarihi:</span>
          <span>{formatItemDate}</span>
        </Col>
      </Row>

      <Divider style={{ margin: "12px 0" }} />

      <Row>
        <>
          <Col span={24}>
            <Table
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{
                overflowX: "auto",
                maxHeight: "100%",
                width: "100%",
              }}
              columns={columns}
              onDataStateChange={dataStateChange}
              dataSource={tableData.data}
              loading={tableData.loading}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              sortable={true}
              rowKey="id"
            ></Table>
          </Col>
        </>
      </Row>

      <Row style={{ marginTop: "20px", marginRight: 20 }}>
        <Col
          span={24}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: 200,
          }}
        >
          <Table
            dataSource={summaryDataSource}
            columns={summaryColumns}
            pagination={false}
            showHeader={false}
            bordered
            size="medium"
            style={{ width: "500px" }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default FirmTrackingTransactionDetail;
